<div class="custom-alert-container" *ngIf="displayAlertBox">
    <div class="custom-alert {{alertMaxWidthClassName}}" [style.borderColor]="activeTheme?.activeThemeStroke">
        <span class="custom-alert__content" [innerHTML]="alertMessage"></span>
        <span class="alert-bottom-bar">
            <a href="javascript:void(0)" class="custom-alert__Confirm" (click)="confirmClick()">OK</a>
            <a href="javascript:void(0)" class="custom-alert__Dismiss" *ngIf="alertType.toLowerCase() === 'confirm'" (click)="dismiss()">Cancel</a>
        </span>
    </div>
</div>